export default __webpack_public_path__ + "static/media/edition-1-rot.effad5c1.svg";